import { useTranslation } from 'react-i18next';
import { ImageComponent } from '@/components/Image';
import { VipTransferCardFactory } from '@/modules/vip/Steps/components/VipTransfer/components/TransferRequestCard';
import { useGetCommonStore } from '@/store';
import { LoyaltyBenefits } from './components/LoyaltyBenefits';
import { VipTransfer } from './components/VipTransfer';
import { ScStepsBenefitsContainer, ScStepsSection } from './styled';

export const StepsSection = () => {
  const { t } = useTranslation('vip');
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  return (
    <ScStepsSection>
      <div className="text-wrapper">
        <span className="title">{t('steps.title')}</span>
        <span className="description">{t('steps.description')}</span>
      </div>
      <div className="containers-wrapper">
        <ScStepsBenefitsContainer>
          <LoyaltyBenefits />
          <ImageComponent
            alt="loyalty-benefits"
            className="benefits-img"
            height={400}
            src="/vip/loyalty-benefits-img.webp"
            width={536}
          />
        </ScStepsBenefitsContainer>
        <ScStepsBenefitsContainer $isOneCol={isAuthenticated}>
          <VipTransfer />
          <VipTransferCardFactory />
        </ScStepsBenefitsContainer>
      </div>
    </ScStepsSection>
  );
};
